module.exports = __webpack_public_path__ + "static/img/dobrowolski.5d59a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dobrowolski.png
// module id = qMNn
// module chunks = 1